import React from "react";
import logo_picturenaming from "../assets/images/app-picturenaming.png";
import logo_copyright from "../assets/images/app-copyright.png";
import logo_kidspeak from "../assets/images/logo_kidspeak.png";
import logo_wordsignsay from "../assets/images/app-wordsignsay.png";
import logo_maze from "../assets/images/logo_maze.png";
import logo_wordmark from "../assets/images/logo_wordmark.png";
import logo_slashtest from "../assets/images/logo_slashtest.png";
import logo_kidsign from "../assets/images/app-kidsignsay.png";
import {connect} from "react-redux";

const ComponentToPrint = React.forwardRef((props, ref) => {
    return (
        <div ref={ref}>
            <div style={{ marginTop:-70}}>
                <div  style={{fontFamily: "mainFont", fontSize:40}}>A GUIDE TO SELECTING APPS</div>
            </div>
            <div className="row">
                <div className="col-sm-4" style={{marginTop:30}}>
                    <div className="row">
                        <div style={{width:110, float:"left"}}>
                            <ul className="nav nav-pills pill-sm" >
                                <li >
                                    <a data-toggle="pill"  >
                                        <img src={logo_picturenaming} style={{width:100, height:100}}  border="0"/>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-sm-6" style={{marginTop:30, width:"calc(100% - 170px)"}}>
                            <div  style={{fontSize:16}}>PICTURE NAMING</div>
                            <div  style={{fontSize:14}}>Student is developing signed and/or spoken language </div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-4" style={{ marginTop:30}}>
                    <div className="row">
                        <div style={{width:110, float:"left"}}>
                            <ul className="nav nav-pills pill-sm" >
                                <li >
                                    <a data-toggle="pill"  >
                                        <img src={logo_copyright} style={{width:100, height:100}}  border="0"/>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-sm-6" style={{marginTop:30, width:"calc(100% - 170px)"}}>
                            <div  style={{fontSize:16}}>COPY RIGHT</div>
                            <div  style={{fontSize:14}}>Student is developing sign skills and/or communicates using ASL</div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-4" style={{marginTop:30}}>
                    <div className="row">
                        <div style={{width:110, float:"left"}}>
                            <ul className="nav nav-pills pill-sm" >
                                <li >
                                    <a data-toggle="pill"  >
                                        <img src={logo_kidspeak} style={{width:100, height:100}}  border="0"/>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-sm-6" style={{marginTop:30, width:"calc(100% - 170px)"}}>
                            <div  style={{fontSize:16}}>KID SPEAK</div>
                            <div  style={{fontSize:14}}>Student reads English text (grades 1-6) AND has intelligible spoken language</div>
                        </div>
                    </div>
                </div>

            </div>

            <div className="row">
                <div className="col-sm-4" style={{marginTop:30}}>
                    <div className="row">
                        <div style={{width:110, float:"left"}}>
                            <ul className="nav nav-pills pill-sm" >
                                <li >
                                    <a data-toggle="pill"  >
                                        <img src={logo_wordsignsay} style={{width:100, height:100}}  border="0"/>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-sm-6" style={{marginTop:30, width:"calc(100% - 170px)"}}>
                            <div  style={{fontSize:16}}>WORD SIGN/SAY</div>
                            <div  style={{fontSize:14}}>Student has a signed and/or spoken language base and beginning to identify words in text </div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-4" style={{marginTop:30}}>
                    <div className="row">
                        <div style={{width:110, float:"left"}}>
                            <ul className="nav nav-pills pill-sm" >
                                <li >
                                    <a data-toggle="pill"  >
                                        <img src={logo_maze} style={{width:100, height:100}}  border="0"/>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-sm-6" style={{marginTop:30, width:"calc(100% - 170px)"}}>
                            <div  style={{fontSize:16}}>MAZE</div>
                            <div  style={{fontSize:14}}>Student reads English text (grades 2-6)</div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-4" style={{ marginTop:30}}>
                    <div className="row">
                        <div style={{width:110, float:"left"}}>
                            <ul className="nav nav-pills pill-sm" >
                                <li >
                                    <a data-toggle="pill"  >
                                        <img src={logo_wordmark} style={{width:100, height:100}}  border="0"/>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-sm-6" style={{marginTop:30, width:"calc(100% - 170px)"}}>
                            <div  style={{fontSize:16}}>WORD MARK</div>
                            <div  style={{fontSize:14}}>Student produces written expression and narratives and uses the e-keyboard</div>
                        </div>
                    </div>
                </div>

            </div>

            <div className="row">
                <div className="col-sm-4" style={{ marginTop:30}}>
                    <div className="row">
                        <div style={{width:110, float:"left"}}>
                            <ul className="nav nav-pills pill-sm" >
                                <li >
                                    <a data-toggle="pill"  >
                                        <img src={logo_slashtest} style={{width:100, height:100}}  border="0"/>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-sm-6" style={{marginTop:30, width:"calc(100% - 170px)"}}>
                            <div  style={{fontSize:16}}>SLASH</div>
                            <div  style={{fontSize:14}}>Student is developing English language patterns OR reads isolated words</div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-4" style={{ marginTop:30}}>
                    <div className="row">
                        <div style={{width:110, float:"left"}}>
                            <ul className="nav nav-pills pill-sm" >
                                <li >
                                    <a data-toggle="pill"  >
                                        <img src={logo_kidsign} style={{width:100, height:100}}  border="0"/>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-sm-6" style={{marginTop:30, width:"calc(100% - 170px)"}}>
                            <div  style={{fontSize:16}}>KID SIGN/SAY</div>
                            <div  style={{fontSize:14}}>Student reads English text (grades 2-6) and is fluent in ASL or spoken English
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    );
});

export default ComponentToPrint;


// WEBPACK FOOTER //
// ./src/TeachersComponent/ComponentToPrint.js